/**
 * Shared Currency Constants
 *
 * IMPORTANT: This is a TEMPORARY solution for currency handling.
 * Currently defaults to CAD as the primary currency with quick-and-dirty
 * vendor-level overrides stored in Company metadata.
 *
 * TODO: Future refactoring needed for:
 * - Multi-currency support per vendor
 * - Currency conversion rate history
 * - Proper currency management system
 * - Organization-level default currency (not hardcoded CAD)
 * - Per-invoice currency vs vendor default currency
 *
 * @see backend/src/db/models/companies/Company.model.ts - Company.metadata.defaultCurrency
 * @see frontend/src/pages/authenticated/core/spreadsheets/ManualRebateCSVUpload.tsx
 * @see frontend/src/pages/authenticated/core/spreadsheets/ConvertDataPageWorkflow.tsx
 */

/**
 * Supported currency codes
 *
 * NOTE: Currently hardcoded to CAD as default. This needs to be
 * refactored to support organization-level defaults and proper
 * multi-currency handling in the future.
 */
export const CURRENCY_CODES = {
  CAD: "CAD",
  USD: "USD",
  EUR: "EUR",
  GBP: "GBP",
} as const;

/**
 * Type for currency codes
 */
export type CurrencyCode = (typeof CURRENCY_CODES)[keyof typeof CURRENCY_CODES];

/**
 * Array of currency code values for dropdowns/selectors
 */
export const CURRENCY_CODE_VALUES = Object.values(CURRENCY_CODES);

/**
 * Default currency code
 *
 * IMPORTANT: This is hardcoded to CAD as a temporary solution.
 * Future refactoring should make this configurable at the organization level.
 */
export const DEFAULT_CURRENCY_CODE: CurrencyCode = CURRENCY_CODES.USD;
